import { Button } from "@mui/material"
import { useEffect } from "react"
import CrossIcon from "../assets/icons/cross-icon"
import TimeIcon from "../assets/icons/time-icon"
import { finishWebView } from "../shared/app-interface"
import { APP_INTERACTION_TYPES } from "../shared/constants"
import { DOC_TYPES } from "../shared/constants/assessment-flow"
import { EVENTS } from "../shared/constants/MIXAPANEL_EVENTS"
import { useAssessmentStore } from "../shared/store"
import { getSectionName, trackMixpanelEvent } from "../utils/helpers"
import BottomSheet from "./bottom-sheet"

const GlobalBottomSheet = () => {
    const {
        openExitFlow,
        assesmentQuestions,
        setOpenExitFlow,
        setOpenSuccessFlow,
        currentStep,
    } = useAssessmentStore((state) => state)
    const isVasFlow = assesmentQuestions?.mandatory
    const entity = assesmentQuestions?.questions[currentStep]?.entity_type

    const handleGetBack = () => {
        setOpenExitFlow(false)
    }
    const handleExitWeb = () => {
        const data = {
            intent: "exit",
            flowType: isVasFlow ? "vas" : "enrichment",
        }
        let webSuccessFlow = sessionStorage.getItem("web_success_flow") as string
        webSuccessFlow = JSON.parse(webSuccessFlow)

        if (isVasFlow) {
            finishWebView(JSON.stringify(data))
        } else {
            // set success Drawer open and close exit sheet
            // add variable in session storage access here
            if (!webSuccessFlow) {
                const data = {
                    intent: "navigate",
                    flowType: isVasFlow ? "vas" : "enrichment",
                    navigateTo: "screen_details",
                }
                finishWebView(JSON.stringify(data))
            } else {
                setOpenExitFlow(false)
                setOpenSuccessFlow(true)
            }
        }
    }

    useEffect(() => {
        const backPressListener = () => {
            trackMixpanelEvent(EVENTS.ASSESSMENT_BACKPRESS, {
                "Section Name": getSectionName(entity),
            })
            const popupStacks = useAssessmentStore.getState().popupStacks
            if (popupStacks.length < 1) {
                setOpenExitFlow(true)
            } else {
                setOpenExitFlow(false)
            }
        }
        window.addEventListener(APP_INTERACTION_TYPES.BACK_PRESS, backPressListener)
        return () => {
            window.removeEventListener(
                APP_INTERACTION_TYPES.BACK_PRESS,
                backPressListener
            )
        }
    }, [setOpenExitFlow])

    return (
        <BottomSheet
            sheetId="global-sheet"
            onClose={() => null}
            open={openExitFlow}
            anchor="bottom"
            PaperProps={{
                sx: {
                    borderRadius: "16px 16px 0 0",
                },
            }}
        >
            <div>
                <div className="flex justify-between pt-6 px-4 pb-4">
                    <span>Do you want to exit?</span>
                    <CrossIcon onClick={handleGetBack} />
                </div>
                <div className="border-solid border border-onSurface-grey-100 "></div>
                <div className="flex flex-col px-4 pt-4 gap-4">
                    {isVasFlow ? (
                        <div>
                            Your application will not be sent to HR if you dont complete
                            the mandatory steps.
                        </div>
                    ) : (
                        <div>
                            Before you exit, complete this step to be in the top 15% and
                            stand out to HR.
                        </div>
                    )}
                    <div className="flex items-center gap-1">
                        Takes only <TimeIcon />
                        <span className="text-[#2F68E3]">1 min</span>
                    </div>
                </div>
                <footer className="relative bottom-0 w-full overflow-y-scroll ">
                    <div className="flex w-full flex-col items-center justify-center px-4 gap-2 py-4">
                        <Button fullWidth onClick={handleGetBack}>
                            <span>Continue applying</span>
                        </Button>

                        <Button fullWidth variant="outlined" onClick={handleExitWeb}>
                            {isVasFlow ? (
                                <span>Exit, I&apos;ll do it later</span>
                            ) : (
                                <span>Exit</span>
                            )}
                        </Button>
                    </div>
                </footer>
            </div>
        </BottomSheet>
    )
}

export default GlobalBottomSheet
